import type { ITraffic } from "app/pages/industry-analysis/market-builder/tabs/industry/table/types";

import { INITIAL_TRAFFIC } from "app/pages/industry-analysis/market-builder/tabs/industry/table/constants";

export const getSelectedFiltersAmount = (traffic: ITraffic): number => {
    const { monthlyVisits, uniqueUsers, isUniqueToggle } = traffic;
    let selectedFiltersAmount = 0;
    const { monthlyVisits: initialMonthlyVisits, uniqueUsers: initialUniqueUsers } = INITIAL_TRAFFIC;
    if (monthlyVisits.to !== initialMonthlyVisits.to || monthlyVisits.from !== initialMonthlyVisits.from) {
        selectedFiltersAmount = selectedFiltersAmount + 1;
    }
    if (uniqueUsers.to !== initialUniqueUsers.to || uniqueUsers.from !== initialUniqueUsers.from) {
        selectedFiltersAmount = selectedFiltersAmount + 1;
    }
    if (isUniqueToggle) {
        selectedFiltersAmount = selectedFiltersAmount + 1;
    }
    return selectedFiltersAmount;
};
